module.exports = __webpack_public_path__ + "static/media/itau-unibanco.91f4f629.jpg";